import { React, useEffect, useState, useContext } from 'react';
import './account.css'
import { useNavigate, Link } from 'react-router-dom'
import Header from '../../components/molecules/Header';
import Footer from '../../components/molecules/Footer';
import { Alert, Container, Table, Badge } from 'react-bootstrap';
import ApiService from '../../helpers/ApiServices';
import { TokenService } from '../../helpers/StorageServices';
import { UserContext } from '../../components/states/contexts/UserContext';
import constants from '../../helpers/Constants';


const Accounts = () => {
    const [accounts, setAccounts] = useState([]);
    const { user, dispatch } = useContext(UserContext);
    const navigate = useNavigate()

    const findAllAccounts = async () => {
        ApiService.setHeader();
        ApiService.get('account').then(response => {
            setAccounts(response.data.documents)

        }).catch(err => {
            navigate('/')
        })
    }

    const handleRowClick = (flexId) => {
        window.location.replace(`https://${flexId}.app.pctflex.com/auth/?flexAuth=${TokenService.getToken()}`)
    }




    useEffect(() => {
        findAllAccounts();
    }, []);


    return (
        <div className='accounts'>
            <Header />

            <Container className='mt-4'>
                <Alert variant='success' style={{ backgroundColor: "#b4ddd3" }}>
                    Please select an account.
                </Alert>
                <Table striped bordered hover size="sm">
                    <thead>
                        <tr>
                            <th>ACCOUNT NAME</th>
                            <th>FLEX ID</th>
                            <th>ACCOUNT TYPE</th>
                        </tr>
                    </thead>
                    <tbody>
                        {accounts.map(account => {
                            const isSandbox = account.environment === 'SANDBOX';

                            return <tr key={account._id} onClick={() => handleRowClick(account.flexId)} style={{ cursor: 'pointer' }} >
                                <td>{account?.name}</td>
                                <td><code>{account?.flexId}</code></td>
                                <td>
                                    <Badge bg={isSandbox ? "secondary" : "teal"} style={{ backgroundColor: isSandbox ? "#6c757d" : "#009999" }}>
                                        {account.environment || 'PRODUCTION'}
                                    </Badge>
                                </td>
                                {/* <td> <a href={`https://${account.flexId}.app.pctflex.com/auth/?flexAuth=${TokenService.getToken()}`}>Select</a></td> */}
                                {/* <td> <a href={`http://localhost:3000/auth/?flexAuth=${TokenService.getToken()}`}>Select</a></td> */}
                            </tr>
                        })}
                    </tbody>
                </Table>

            </Container>


            {/* <Footer /> */}
        </div>
    );
}

export default Accounts;
